export interface IAddonDetails {
    broadband: IBroadband;
}

export enum EBroadbandAddonCode {
    GOMO_WIFI_MESH_6 = "GOMO_WIFI_MESH_6",
}

export interface IBroadband {
    serviceId: number;
    addons: IBroadbandAddon[];
}

export interface IBroadbandAddon {
    code: EBroadbandAddonCode;
    description: string;
    maxQuantity: number;
    price: number;
    subscribedAddons: ISubscribedAddon[];
}

export enum ESubscribedAddonStatus {
    INITIAL = "INITIAL",
    ACTIVE = "ACTIVE",
    TERMINATED = "TERMINATED",
}

interface IAddon {
    id: number;
    price: number;
}

export interface IOngoingAddon extends IAddon {
    deliveryAddress: string;
    status: ESubscribedAddonStatus.INITIAL;
}

export interface IActiveAddon extends IAddon {
    status: ESubscribedAddonStatus.ACTIVE;
}

export interface ITerminatedAddon extends IAddon {
    shouldReturnEquipments: boolean;
    status: ESubscribedAddonStatus.TERMINATED;
}

export type ISubscribedAddon = IOngoingAddon | IActiveAddon | ITerminatedAddon;
